import styled from '@emotion/styled';
import * as vars from '@shared/styles/abstracts/vars.module.scss';

type StyleType = {
  $isOpen: boolean;
};
export const SAccordion = styled.div`
  position: relative;
`;

export const STitle = styled.span<StyleType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${vars.colorTextSecondary};
  font-size: ${vars.fontSmall};
  position: relative;
  height: 26px;

  svg {
    color: ${vars.colorTextSecondary};
    transform: rotate(${(props) => (props.$isOpen ? '90deg' : '-90deg')});
    transition: transform 0.2s ease-out;

    width: 26px;
    height: 26px;
    margin-left: auto;
    //margin-right: 9px;
  }
`;

export const SBody = styled.div<StyleType>`
  padding-top: ${(props) => (props.$isOpen ? '6px' : 'unset')};
  max-height: ${(props) => (props.$isOpen ? '400px' : '0')};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.$isOpen ? '1' : '0')};
  transition:
    max-height 0.1s ease-out,
    padding-top 0.1s ease-out,
    opacity 0.3s ease-out;
`;
